import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import {
    BroadcastersWrapper,
    BroadcastersSectionTitle,
    BroadcastersSection,
    ItemList,
    TVSingleLine
} from './Broadcasters.style';

import { withTheme } from 'styled-components';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';

import Skeleton from '@mlb/react-patterns/v4/components/Skeleton/skeleton';

const generateList = (teamName, teamList, isLoading) => {
    if (isLoading) {
        return <Skeleton width='250px' height='14px' margin='2px' />;
    }
    return teamList.length ? <ItemList>{`${teamName} - ${teamList.join(', ')}`}</ItemList> : null;
};

const generateSection = (homeName, awayName, mediaTitle, homeMedia, awayMedia, nationalMedia, nationalLabel, isLoading) => (
    <BroadcastersSection>
        <BroadcastersSectionTitle>
            { isLoading
                ? <Skeleton width='50px' height='14px' margin='8px' />
                : mediaTitle
            }
        </BroadcastersSectionTitle>
        { generateList(homeName, homeMedia, isLoading) }
        { generateList(awayName, awayMedia, isLoading) }
        { generateList(nationalLabel, nationalMedia, isLoading) }
    </BroadcastersSection>
);

const Broadcasters = ({
    homeName,
    homeTv = [],
    homeAudio = [],
    awayName,
    awayTv = [],
    awayAudio = [],
    nationalTv = [],
    nationalAudio = [],
    isLoading = false,
    tvOnlyString
}) => {
    const watchString = useTranslator('label_watch', 'Watch');
    const listenString = useTranslator('label_listen', 'Listen');
    const tbdString = useTranslator('label_tbd', 'TBD');
    const nationalString = useTranslator('label_national', 'National');

    const tvSection = useMemo(() => {
        if (homeTv.length || awayTv.length || nationalTv.length) {
            return generateSection(homeName, awayName, watchString, homeTv, awayTv, nationalTv, nationalString, isLoading);
        }
        return null;
    }, [homeName, awayName, homeTv, awayTv, nationalTv, isLoading]);

    const audioSection = useMemo(() => {
        if (homeAudio.length || awayAudio.length || nationalAudio.length) {
            return generateSection(homeName, awayName, listenString, homeAudio, awayAudio, nationalAudio, nationalString, isLoading);
        }
        return null;
    }, [homeName, awayName, homeAudio, awayAudio, nationalAudio, isLoading]);

    const tvSingleLine = useMemo(() => {
        const tvArr = [...homeTv, ...awayTv, ...nationalTv];
        return <TVSingleLine>{tvArr.join(', ')}</TVSingleLine>;
    }, [homeTv, awayTv, nationalTv]);

    return (
        <>
            {tvOnlyString
                ? tvSingleLine
                : <BroadcastersWrapper>
                    { tvSection || audioSection
                        ? <>
                            { tvSection }
                            { audioSection }
                        </>
                        : <div>
                            { tbdString }
                        </div>
                    }
                </BroadcastersWrapper>
            }

        </>
    );
};

Broadcasters.propTypes = {
    homeName: PropTypes.string,
    awayName: PropTypes.string,
    homeTv: PropTypes.arrayOf(PropTypes.string),
    awayTv: PropTypes.arrayOf(PropTypes.string),
    nationalTv: PropTypes.arrayOf(PropTypes.string),
    homeAudio: PropTypes.arrayOf(PropTypes.string),
    awayAudio: PropTypes.arrayOf(PropTypes.string),
    nationalAudio: PropTypes.arrayOf(PropTypes.string),
    isLoading: PropTypes.bool
};

export default withTheme(Broadcasters);
